{
  "$id": "wealthlane://forms/role-publish",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../role-publish.domain.json",
  "properties": {
    "sourceRoleId": {
      "$ref": "module://role-publish#properties/sourceRoleId",
      "required": true
    },
    "destinationCompanyId": {
      "$ref": "module://role-publish#properties/destinationCompanyId",
      "required": true,
      "adapterProps": {
        "multiple": true
      },
      "hiddenWhen": {
        "field": "#/properties/sourceRoleId",
        "isEmpty": true
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_ROLE_PUBLISH",
      "refreshEntities": ["RolePublish"],
      "invalidateQueries": ["getRolePublishList"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Role Published successfully."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_ROLE_PUBLISH_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Role Published edited."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_ROLE_PUBLISH_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
